import { render, staticRenderFns } from "./ad-manager.vue?vue&type=template&id=6b6dee2d&scoped=true&"
import script from "./ad-manager.vue?vue&type=script&lang=js&"
export * from "./ad-manager.vue?vue&type=script&lang=js&"
import style0 from "./ad-manager.vue?vue&type=style&index=0&id=6b6dee2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6dee2d",
  null
  
)

export default component.exports